// Copied from Prisma generated code since @notAnEntity enums are not generated in @doss/prisma/types

export enum BreadcrumbObjectType {
  ACTION = 'ACTION',
  ACTION_STEP = 'ACTION_STEP',
  CHART = 'CHART',
  DOCUMENT = 'DOCUMENT',
  EMBED = 'EMBED',
  FORM = 'FORM',
  FORM_V2 = 'FORM_V2',
  FORM_V2_INPUT = 'FORM_V2_INPUT',
  FORM_CATEGORY = 'FORM_CATEGORY',
  FORM_FIELD = 'FORM_FIELD',
  FORM_PAGE = 'FORM_PAGE',
  ORGANIZATION = 'ORGANIZATION',
  PIVOT_TABLE = 'PIVOT_TABLE',
  PROJECT = 'PROJECT',
  TABLE = 'TABLE',
  TABLE_CELL = 'TABLE_CELL',
  TABLE_COLUMN = 'TABLE_COLUMN',
  TABLE_ROW = 'TABLE_ROW',
  USER = 'USER',
  WORKFLOW = 'WORKFLOW',
  WORKFLOW_V2 = 'WORKFLOW_V2',
  WORKFLOW_V2_TRIGGER = 'WORKFLOW_V2_TRIGGER',
  WORKSPACE = 'WORKSPACE',
}

export enum ChartSubType {
  AREA = 'AREA',
  BAR = 'BAR',
  COLUMN = 'COLUMN',
  DONUT = 'DONUT',
  GAUGE = 'GAUGE',
  HISTOGRAM = 'HISTOGRAM',
  LINE = 'LINE',
  METRIC = 'METRIC',
  PIE = 'PIE',
  PIVOT_TABLE = 'PIVOT_TABLE',
  SCATTERPLOT = 'SCATTERPLOT',
}
